import {
  Component,
  Input,
  Output,
  EventEmitter,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import '@cigna/leaf-web/lib/wc/components/select-tile/select-tile';
import type { LeafSelectTile } from '@cigna/leaf-web/lib/wc';

@Component({
  selector: 'cigna-leaf-select-tile',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-select-tile
      [label]="label"
      [sideText]="sideText"
      [svg]="svg"
      [isError]="isError"
      [disabled]="disabled"
      [isOptional]="isOptional"
      [type]="type"
      [optionalText]="optionalText"
      [variant]="variant"
      [required]="required"
      [checked]="checked"
      [fieldId]="fieldId"
      [name]="name"
      (change)="change.emit($event)"
      (input)="input.emit($event)"
      (click)="click.emit($event)"
      (keydown)="keydown.emit($event)"
    >
      <ng-content></ng-content>
    </leaf-select-tile>
  `,
})
export class CignaLeafSelectTileComponent {
  @Input() label: LeafSelectTile['label'];
  @Input() sideText: LeafSelectTile['sideText'];
  @Input() svg: LeafSelectTile['svg'];
  @Input() isError: LeafSelectTile['isError'];
  @Input() disabled: LeafSelectTile['disabled'];
  @Input() isOptional: LeafSelectTile['isOptional'];
  @Input() type: LeafSelectTile['type'];
  @Input() optionalText: LeafSelectTile['optionalText'];
  @Input() variant: LeafSelectTile['variant'];
  @Input() required: LeafSelectTile['required'];
  @Input() checked: LeafSelectTile['checked'];
  @Input() fieldId: LeafSelectTile['fieldId'];
  @Input() name: LeafSelectTile['name'];

  @Output() change = new EventEmitter<Event>();
  @Output() input = new EventEmitter<Event>();
  @Output() click = new EventEmitter<Event>();
  @Output() keydown = new EventEmitter<Event>();
}
